import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/pperfunnel-ui-v1_hotfix_26.10.05@2/app/global-error.tsx");
